export enum EAmplitudeEvent {
  OverviewV2View = "overview_v2_view",
  OverviewLegacyView = "overview_legacy_view",
}
